import { useQuery } from "@tanstack/react-query";
import {
  fetchGuides,
  fetchCategoryPages,
  fetchPlatformPages,
  fetchComparisonPages,
  fetchLegalPages,
  fetchPolls,
  fetchAnnouncements,
  fetchAnnouncementBySlug,
  fetchJournalists,
  fetchEditorialGuidelines,
  fetchPressKit,
  fetchAboutPage,
  fetchContactPage,
  type SanityGuide,
  type SanityCategoryPage,
  type SanityPlatformPage,
  type SanityComparisonPage,
  type SanityLegalPage,
  type SanityPoll,
  type SanityAnnouncement,
  type SanityJournalist,
  type SanityEditorialGuidelines,
  type SanityPressKit,
  type SanityAboutPage,
  type SanityContactPage,
} from "@/lib/sanityQueries";

const STALE = 5 * 60 * 1000;
const SHARING = { structuralSharing: true as const };

export function useSanityGuides() {
  return useQuery({ queryKey: ["sanity-guides"], queryFn: fetchGuides, staleTime: STALE, ...SHARING });
}

export function useSanityCategoryPages() {
  return useQuery({ queryKey: ["sanity-category-pages"], queryFn: fetchCategoryPages, staleTime: STALE, ...SHARING });
}

export function useSanityPlatformPages() {
  return useQuery({ queryKey: ["sanity-platform-pages"], queryFn: fetchPlatformPages, staleTime: STALE, ...SHARING });
}

export function useSanityComparisonPages() {
  return useQuery({ queryKey: ["sanity-comparison-pages"], queryFn: fetchComparisonPages, staleTime: STALE, ...SHARING });
}

export function useSanityLegalPages() {
  return useQuery({ queryKey: ["sanity-legal-pages"], queryFn: fetchLegalPages, staleTime: STALE, ...SHARING });
}

export function useSanityPolls() {
  return useQuery({ queryKey: ["sanity-polls"], queryFn: fetchPolls, staleTime: STALE, ...SHARING });
}

export function useSanityAnnouncements() {
  return useQuery({ queryKey: ["sanity-announcements"], queryFn: fetchAnnouncements, staleTime: STALE, ...SHARING });
}

export function useSanityAnnouncementBySlug(slug: string) {
  return useQuery({
    queryKey: ["sanity-announcement", slug],
    queryFn: () => fetchAnnouncementBySlug(slug),
    staleTime: STALE,
    enabled: !!slug,
    ...SHARING,
  });
}

export function useSanityJournalists() {
  return useQuery({ queryKey: ["sanity-journalists"], queryFn: fetchJournalists, staleTime: STALE, ...SHARING });
}

export function useSanityEditorialGuidelines() {
  return useQuery({ queryKey: ["sanity-editorial-guidelines"], queryFn: fetchEditorialGuidelines, staleTime: STALE, ...SHARING });
}

export function useSanityPressKit() {
  return useQuery({ queryKey: ["sanity-press-kit"], queryFn: fetchPressKit, staleTime: STALE, ...SHARING });
}

export function useSanityAboutPage() {
  return useQuery({ queryKey: ["sanity-about-page"], queryFn: fetchAboutPage, staleTime: STALE, ...SHARING });
}

export function useSanityContactPage() {
  return useQuery({ queryKey: ["sanity-contact-page"], queryFn: fetchContactPage, staleTime: STALE, ...SHARING });
}

export type {
  SanityGuide, SanityCategoryPage, SanityPlatformPage, SanityComparisonPage,
  SanityLegalPage, SanityPoll, SanityAnnouncement, SanityJournalist,
  SanityEditorialGuidelines, SanityPressKit, SanityAboutPage, SanityContactPage,
};
